import * as Cookie from 'js-cookie'

export const HasCookiesConsent = () : boolean => Cookie.get('consent') == 'true'
